import { LineGoesUpIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_GOOGLE_LSA_MANAGER: AppConfig = {
  name: 'Ads Manager',
  applicationKey: 'ads-manager',
  type: 'product',
  globalHeaderTitle: 'Ads Manager',
  appSlugForEngagement: AppSlugs.GoogleLsaManager,
  rootPath: '/ads-manager',
  Icon: LineGoesUpIcon,
  descriptionLong: 'Launch and manage pay-per-lead ads for your local market.',
  descriptionShort: 'Launch and manage pay-per-lead ads for your local market.',
  comingSoon: true,
  hideIfNoAccess: true,
};
